<template>
  <div class="">
    <div class="d-flex justify-content-between">
      <div class="font-size-20 fw-bold">Thiết lập ghi chú</div>
      <el-button @click="addNew()" size="mini">Thêm trường</el-button>
    </div>
    <div class="p-2 mt-2" style="border: 1px solid #dcdfe9;overflow-y: auto;max-height: 400px">
      <draggable v-model="data" class="flex-column mt-2" @end="finishSwap">
        <div v-for="(item,index) in data" :key="index">
          <el-card :body-style="{ padding: '0px' }" class="pointer mt-1">
            <div class="d-flex  p-2 m-1">
              <div style="min-width: 30px;padding-top: 2px">{{ item.index + 1 }}</div>
              <div style="min-width: 60px;padding-top: 2px">Tiêu đề</div>
              <el-input v-model="item.title" size="mini" class="flex-1"></el-input>
              <div style="min-width: 62px;padding-top: 2px;margin-left:24px">Phân loại</div>
              <el-select v-model="item.type" default-first-option size="mini" style="width: 150px">

                <el-option v-for="type in types" :key="type.val" :label="type.label"
                           :value="type.val">
                </el-option>
              </el-select>
              <div class="mx-2"></div>


              <el-tooltip class="item pointer mx-2 mt-1" effect="dark"
                          :content="contentHidden(item.hidden)"
                          placement="top">
                <i v-bind:class="item.hidden?'icon-hidden':'icon-visible'" class="font-size-20 text-secondary"
                   @click="hiddenChange(item)" />
              </el-tooltip>
            </div>

          </el-card>
        </div>
      </draggable>
    </div>
    <div class="divider-custom my-2" />
    <div class="d-flex">
      <div class="text-danger fw-semibold">(*)Kéo thả để sắp xếp</div>
      <div class="flex-1"></div>
      <el-button type="danger" size="mini" @click="closePopup()">Hủy</el-button>
      <el-button type="primary" size="mini" @click="save()">Lưu</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoteConfig",
  components: { draggable: () => import("vuedraggable") },
  data() {
    return {
      data: [],
      types: [
        { val: "phone", label: "Số điện thoại" },
        { val: "gmail", label: "Email" },
        { val: "text", label: "Văn bản" },
        { val: "address", label:"Địa chỉ"}
      ]
    };
  },
  methods: {
    hiddenChange(item) {
      item.hidden = !item.hidden;
    },
    contentHidden(value) {
      if (value) return "Hiện";
      return "Ẩn";
    },
    addNew() {
      this.data.push(this.getNew());
      this.sort();
    },
    getNew() {
      return {
        id: 0,
        type: "text",
        title: "Ghi chú " + (this.data.length + 1),
        hidden: false,
        index: this.data.length,
        newId: new Date().getUTCMilliseconds()
      };
    },
    sort() {
      this.data = this.data.sort((a, b) => a.index - b.index);
      this.finishSwap();
    },
    finishSwap() {
      for (var i = 0; i < this.data.length; i++) {
        this.data[i].index = i;
      }
    },
    save() {
      this.$http.post("/api/v2/customer/config", {
        data: this.data
      }).then(() => {
        this.app.customerCodeList = this.data;
        this.closePopup();
      });
    },
    getCode() {
      this.$http.get("/api/v2/customer/getCode").then((resp) => {
        this.data = resp.data;
        this.sort();
      });
    },
    closePopup() {
      this.$bus.$emit("closeNoteConfig", {});
    }
  },
  created() {
    this.getCode();
  }
};
</script>

<style scoped>

</style>
